<script>
import Template from '{Template}/Web/Pages/Market/Partials/MarketTrades.template'
import {math_formatter} from "@/Functions/Math";
import BinanceTradesSocket from "../../../Jetstream/BinanceTradesSocket";
import numeral from 'numeral'; // Import numeral
import moment from 'moment'; // Import moment
import axios from 'axios'; // Import axios



export default Template({
    components: {
        BinanceTradesSocket
    },
    props: {
        market: Object,
    },
    data() {
        return {
            limit: 30,
            fetchInterval: null,
	    
        }
    },
    mounted() {
        
        if(this.market.s) {
            this.fetchHistoricalTrades();
	    
        } else {
	    this.$store.dispatch('fetchMarketTrades', { market: this.market.name });
        }

     console.log('Market trades for', this.market.name, ':', this.$store.getters.getMarketTrades(this.market.name));


    },
    beforeDestroy() {
	
        clearInterval(this.fetchInterval);
    },
    computed: {
        trades: function () {
         
	   
               const marketTrades = this.$store.getters.getMarketTrades(this.market.name);
                

            return _.take(marketTrades.reverse(), this.limit);
	},        
	

    },
    methods: {
        fetchHistoricalTrades() {
            axios.get(route('markets.api.historical.trades'), {
                params: {
                    market: this.market.name
                }
            }).then((response) => {
                if(response.data.success) {
				
                    this.$store.dispatch('setMarketTrades', {market: this.market.name, trades: response.data.trades});
		                    }
            })

	    .catch((error) => {
        console.error('Error fetching historical trades:', error);
      });

        },
       // markets.api.historical.trades
        decimal_format(value, decimal, type = '') {
	
            let formatted = math_formatter(value, decimal);

            if(type == "fiat") {
                if(decimal == 3) {
                    formatted = numeral(formatted).format('0,0.000');
                } else {
                    formatted = numeral(formatted).format('0,0.00');
                }
            }

            return formatted;
        },
        parseTime(date) {
    let formattedDate;

    if (typeof date === 'number') {
        // If the input date is a Unix timestamp in milliseconds
        formattedDate = moment(date).format('HH:mm:ss');
    } else if (typeof date === 'string') {
        // If the input date is in ISO 8601 format
        formattedDate = moment(date).utc().format('HH:mm:ss');
    } else {
        // Handle other cases if necessary
        console.error('Unsupported date format:', date);
        formattedDate = 'Invalid Date';
    }

    
    
    return formattedDate;
},

    },
})
</script>
